export default __webpack_public_path__ + "static/media/fish&chips-Regular.dc175cb0.eot";